<svg class="clinical-chart" [attr.viewBox]="viewBox$ | async">
  <svg:g
    *ngFor="let arch of arches$ | async; trackBy: trackByArch"
    #archChartSurface="prChartSurface"
    class="arch-selector"
    prChartSurface
    prChartedItemsBadgeHover
    [prChartArch]="arch"
    [prSVGTransform]="arch"
    [ngClass]="{
      selected: archChartSurface.selected$ | async,
      disabled: archChartSurface.disabled$ | async
    }"
    [highlightDisabled]="true"
    [view]="arch.display"
  />

  <svg:g
    #mouthChartSurface="prChartSurface"
    class="mouth-selector"
    prChartMouth
    prChartSurface
    prChartedItemsBadgeHover
    [arches]="arches$ | async"
    [element]="element$ | async"
    [view]="mouth$ | async"
    [ngClass]="{
      selected: mouthChartSurface.selected$ | async,
      disabled: mouthChartSurface.disabled$ | async
    }"
    [highlightDisabled]="true"
  />

  <svg:g
    *ngFor="let row of rows$ | async; trackBy: trackByRow"
    [prSVGTransform]="row"
  >
    <svg:g
      *ngFor="let quadrant of row.quadrants; trackBy: trackByQuadrant"
      [prSVGTransform]="quadrant"
    >
      <svg:g
        #quadrantChartSurface="prChartSurface"
        class="quadrant-selector"
        prChartSurface
        prChartedItemsBadgeHover
        [prChartQuadrant]="quadrant"
        [ngClass]="{
          selected: quadrantChartSurface.selected$ | async,
          disabled: quadrantChartSurface.disabled$ | async
        }"
        [highlightDisabled]="true"
        [view]="quadrant.display"
      />

      <svg:g
        *ngFor="let tooth of quadrant.teeth; trackBy: trackByTooth"
        prChartTooth
        [view]="tooth.display"
        [prSVGTransform]="tooth"
        [tooth]="tooth"
      />
    </svg:g>
  </svg:g>
</svg>
